import { TCallResultType, TDirection } from '@/services/zoom_phone_types';
import { ZoomPhoneState } from '../types';

export const types = {
  SET_IS_CALLING: 'SET_IS_CALLING',
  SET_DIRECTION: 'SET_DIRECTION',
  SET_CALL_STARTED_INFO: 'SET_CALL_STARTED_INFO',
  SET_CALL_ENDED_INFO: 'SET_CALL_ENDED_INFO',
  SET_CALL_CONNECTED_INFO: 'SET_CALL_CONNECTED_INFO',
  RESET_CALL_INFO: 'RESET_CALL_INFO',
};

const setCallInfoValueIfNull = <K extends keyof ZoomPhoneState['callInfo']>(state: ZoomPhoneState, key: K, value: ZoomPhoneState['callInfo'][K]): void => {
  if (state.callInfo[key] == null) {
    state.callInfo[key] = value;
  }
};

export const mutations = {
  [types.SET_IS_CALLING] (state: ZoomPhoneState, isCalling: boolean): void {
    state.isCalling = isCalling;
  },
  [types.SET_DIRECTION] (state: ZoomPhoneState, direction: TDirection): void {
    state.callInfo.direction = direction;
  },
  [types.SET_CALL_STARTED_INFO] (state: ZoomPhoneState, { id, startedAt }: { id: string, startedAt: string }): void {
    setCallInfoValueIfNull(state, 'id', id);
    setCallInfoValueIfNull(state, 'startedAt', startedAt);
  },
  [types.SET_CALL_ENDED_INFO] (state: ZoomPhoneState, { id, endedAt, result }: { id: string, endedAt: string, result: TCallResultType }): void {
    setCallInfoValueIfNull(state, 'id', id);
    setCallInfoValueIfNull(state, 'endedAt', endedAt);
    setCallInfoValueIfNull(state, 'result', result);
  },
  [types.SET_CALL_CONNECTED_INFO] (state: ZoomPhoneState, { id, connectedAt }: { id: string, connectedAt: string }): void {
    setCallInfoValueIfNull(state, 'id', id);
    setCallInfoValueIfNull(state, 'connectedAt', connectedAt);
  },
  [types.RESET_CALL_INFO] (state: ZoomPhoneState): void {
    state.callInfo = {
      id: null,
      direction: null,
      startedAt: null,
      connectedAt: null,
      endedAt: null,
      result: null,
    };
  },
};
